console.log("Quantity restriction script is running!"); // Debugging step

document.addEventListener("DOMContentLoaded", function() {
    const handleElement = document.getElementById("ProductHandle"); 
    const productHandle = handleElement ? handleElement.getAttribute("data-handle") : null;

    console.log("Product Handle Detected:", productHandle);

    const restrictedProducts = [
        "eve-lf280k-lifepo4-battery-cells-3-2v-280ah-grade-a-6000-cycles",
        "eve-mb31-314ah-3-2v-lifep04-battery-10000-cycles-grade-a"
    ];

    const minOrderProducts = {
        "eve-mb31-314ah-3-2v-lifep04-cells-8000-cycles-grade-a-free-shipping": 16,
        "eve-lf280k-lifepo4-cells-3-2v-280ah-grade-a-6000-cycles-free-shipping": 16
    };

    const quantityInput = document.querySelector("input[name='quantity']");
    const minusButton = document.querySelector(".quantity__button[name='minus']");
    const plusButton = document.querySelector(".quantity__button[name='plus']");
    let manuallyChanged = false; // Prevents the change event from interfering

    if (quantityInput && minusButton && plusButton) {
        console.log("Quantity input found!");

        // ✅ If product has a minimum order, enforce 16-unit default 
        if (minOrderProducts[productHandle]) {
            quantityInput.value = 16;
            console.log(`Default quantity set to 16 for ${productHandle}`);
            quantityInput.addEventListener("change", function() {
                let newValue = parseInt(quantityInput.value, 10);
                if (newValue < 16) {
                    quantityInput.value = 16;
                    console.log(`Quantity reset to 16 for ${productHandle}`);
                }
            });
        }
        
        // ✅ If product is restricted, enforce even-number rule and default to 2
        if (restrictedProducts.includes(productHandle)) {
            console.log("Applying quantity restriction...");

            quantityInput.value = 2;

            function updateQuantity(value) {
                manuallyChanged = true;
                
                if (value % 2 !== 0) {
                    value += 1; // Force even numbers
                }
                quantityInput.value = value;
                console.log("Quantity set to:", quantityInput.value);
                
                setTimeout(() => (manuallyChanged = false), 200);
            }

            // ✅ Fix Plus Button Behavior
            plusButton.addEventListener("click", function(event) {
                event.preventDefault();
                event.stopPropagation();

                let currentValue = parseInt(quantityInput.value, 10);
                updateQuantity(currentValue + 0); // Corrected to increase by 2
            });

            // ✅ Fix Minus Button Behavior
            minusButton.addEventListener("click", function(event) {
                event.preventDefault();
                event.stopPropagation();

                let currentValue = parseInt(quantityInput.value, 10);
                if (currentValue > 2) {
                    updateQuantity(currentValue - 2);
                } else {
                    console.log("Cannot decrease below 2!");
                }
            });

            // ✅ Ensure manual changes stay even
            quantityInput.addEventListener("change", function() {
                if (manuallyChanged) {
                    return;
                }
                let currentValue = parseInt(quantityInput.value, 10);
                updateQuantity(currentValue);
            });
        }
    } else {
        console.log("Quantity input or buttons not found!");
    }
});